/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AvailableEquipmentFirmwareResponse { 
    id: string;
    name: string;
    version: string;
    createdDate: string;
    isInstalled: boolean;
}

